import React, { useEffect, useState } from 'react'
import { View, TextInput, Image, TouchableOpacity, Text, TouchableWithoutFeedback, Animated, Button } from 'react-native'
import { Ionicons, Feather } from '@expo/vector-icons'
import NavigationMain from '../navigation/stacks/MainNavigation'
import { Loader } from '../customUtils/Components/Loader'
import { getAppVersion, getPrefix } from '../customUtils/AppConstants'
import theme from '../../../theme'
import styles from './loginBiometricStyles'
import { Platform } from 'react-native'
import BottomSheet from '../BottomSheetWrapper'
let BottomSheetScrollView = Platform.OS !== 'web' ? BottomSheet.BottomSheetScrollView : undefined
let BottomSheetView = Platform.OS !== 'web' ? BottomSheet.BottomSheetView : undefined
import { StatusBar } from 'react-native'
import { LoginTheme } from '../../../themeConstants'
import { colorButtonTextEnabled, colorButtonTextDisabled } from '../../../themeConstants'
import { avatarPlaceholder, placeholderGeneral } from '../customUtils/Constants'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { FlatList, ScrollView } from 'react-native-gesture-handler'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'
import { BiometricsUserData, LoginBiometricsStorage } from '../../utils/LoginBiometricsStorage'
import { authenticateWithBiometrics, deleteAvatarUser, validateConnectionNetwork } from '../../utils/functions.utils'
import { getImageStogeUrl } from '../imageUploader/ImageStorage'
import { getLanguageFile } from '../../translations/i18n'
import { useAndroidNavBarHeight } from '../customUtils/hooks/useAndroidNavBarHeight'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

const languageFile = getLanguageFile()
const isWeb = Platform.OS === 'web'

interface ILoginBiometric {
    handleLoginOtherUser: () => void
    handleLogin: (userNameParam: any, passwordParam: any) => Promise<void>
    isLoadingButtonLogin: boolean
}
export const LoginBiometric = ({ handleLoginOtherUser, handleLogin, isLoadingButtonLogin }: ILoginBiometric) => {
    const [users, setUsers] = useState<BiometricsUserData[]>([])
    const [isLoading, setIsLoading] = useState(false)
    const [deleteUserModal, setDeleteUserModal] = useState({
        status: false,
        title: '¿Deseas borrar el ingreso automático de USUARIO?',
        desc: 'Podrás volver a seleccionarlo o completar tus datos manualmente en el formulario login.',
        userLogin: null,
        avatar: null,
    })
    const [viewModalConnection, setViewModalConnection] = useState(false)

    useEffect(() => {
        const fetchUsersWithAvatars = async () => {
            setIsLoading(true)
            try {
                const users = await LoginBiometricsStorage.getAllDataBiometrics()

                setUsers(users)
            } catch (error) {
                console.error('Error al obtener usuarios con avatares:', error)
            } finally {
                setIsLoading(false)
            }
        }

        fetchUsersWithAvatars()
    }, [])
    const insets = useSafeAreaInsets()
    const deleteUserModalContent = (title, desc) => {
        let buttonGoto = 'Confirmar'
        let button = 'Cancelar'
        const handleDelete = () => {
            handleDeleteUser(deleteUserModal.userLogin, deleteUserModal.avatar).then((res) => {
                setDeleteUserModal({
                    status: false,
                    title: '',
                    desc: '',
                    userLogin: null,
                    avatar: null,
                })
            })
        }

        return (
            <>
                <BottomSheetAlert
                    image={{ uri: deleteUserModal.avatar && deleteUserModal.avatar != '' ? deleteUserModal.avatar : avatarPlaceholder }} //deleteUserModal
                    title={title}
                    desc={desc}
                    buttonGoto={buttonGoto}
                    goto={handleDelete}
                    button={button}
                    closeBottomSheet={() =>
                        setDeleteUserModal({
                            status: false,
                            title: '',
                            desc: '',
                            userLogin: null,
                            avatar: null,
                        })
                    }
                />
            </>
        )
    }

    const viewModalNotConection = () => {
        const button = languageFile.accept
        const TITLE_NO_CONECTION = languageFile.modal_not_connected
        const DESC_NO_CONECTION = languageFile.modal_not_connected_message

        return (
            <BottomSheetAlert
                image={require('../../../assets/loginError.png')}
                title={TITLE_NO_CONECTION}
                desc={DESC_NO_CONECTION}
                button={button}
                closeBottomSheet={() => setViewModalConnection(false)}
            />
        )
    }

    const handleLoginBiometric = async (user: BiometricsUserData) => {
        try {
            const response = await authenticateWithBiometrics()
            const hasConnection = await validateConnectionNetwork()
            if (!hasConnection) {
                setViewModalConnection(true)
                return
            }
            if (response) {
                setIsLoading(true)
                await handleLogin(user.username, user.password).finally(() => {
                    setIsLoading(false)
                })
            } else {
                console.error('Error al autenticar con biometría')
            }
        } catch {
            console.error('Error al autenticar con biometría')
        } finally {
            setIsLoading(false)
        }
    }

    const handleDeleteUser = async (userLogin: string, avatar: string) => {
        try {
            if (!userLogin) return
            await LoginBiometricsStorage.removeDataBiometricsUser(userLogin)
            const users = await LoginBiometricsStorage.getAllDataBiometrics()
            setUsers(users)
            redirectToLoginIfNoUsers(users.length)
            deleteAvatarUser(avatar)
        } catch (error) {
            console.error('Error al eliminar usuario:', error)
        }
    }

    const redirectToLoginIfNoUsers = (cantUsers: number) => {
        if (cantUsers === 0) {
            setIsLoading(true)

            setTimeout(() => {
                handleLoginOtherUser()
                setIsLoading(true)
            }, 2000)
        }
    }

    const onPressModalUser = (userLogin: string, username: string, avatar: string) => {
        setDeleteUserModal({
            status: true,
            title: `¿Deseas borrar el ingreso automático de ${username}?`,
            desc: 'Al eliminar el usuario, deberás volver a ingresarlo manualmente a la lista.',
            userLogin: userLogin,
            avatar: avatar,
        })
    }
    const navBarHeight = useAndroidNavBarHeight()

    return (
        <>
            {!isLoading ? (
                <View style={[styles.containerLogin, { alignContent: 'center', justifyContent: 'center' }]}>
                    <View style={[{ alignSelf: 'center', width: '100%' }, isWeb && { maxWidth: 436 }]}>
                        <Image style={styles.image} source={require('../../../assets/client.png')} resizeMode='contain' />
                        <View style={{ flexDirection: 'row', justifyContent: 'center', paddingHorizontal: 12, marginBottom: 12 }}>
                            <Text style={styles.start}>Inicio Biométrico</Text>
                            <View style={{ width: 4 }}></View>
                            <Ionicons name='finger-print-outline' size={24} color={theme.colors.darkGray} />
                        </View>

                        <FlatList
                            style={{ maxHeight: '70%', marginBottom: 15, minHeight: '15%' }}
                            data={users as BiometricsUserData[]}
                            keyExtractor={(item, index) => index.toString()} // Usa el índice como clave
                            horizontal={false}
                            showsHorizontalScrollIndicator={false}
                            showsVerticalScrollIndicator={false}
                            // contentContainerStyle={{
                            //     flexGrow: 0, // hace que el contenido ocupe todo el alto disponible
                            //     justifyContent: 'center', // centra vertical si hay espacio
                            // }}
                            renderItem={({ item }) => (
                                <LoginBiometricItem
                                    userLogin={item.username}
                                    avatar={item.avatar}
                                    user_name={item.user_name}
                                    email={item.email}
                                    last_connection={''}
                                    setDeleteUserModal={setDeleteUserModal} // Pasamos setDeleteUserModal como prop
                                    handleLoginBiometric={() => handleLoginBiometric(item)} // Pasamos handleLoginBiometric como prop
                                    onPressModalUser={() => onPressModalUser(item.username, item.user_name, item.avatar)} // Pasamos onPressModalUser como prop
                                />
                            )}
                        />
                        <View style={[styles.buttonContainer]}>
                            <TouchableOpacity onPress={handleLoginOtherUser}>
                                <Text style={styles.floatingButtonText}>Ingresar con otro usuario</Text>
                            </TouchableOpacity>
                        </View>
                    </View>
                    <View style={{ position: 'absolute', bottom: 0, alignSelf: 'center' }}>
                        <Text style={[styles.version]}>{getAppVersion()}</Text>
                        <View style={{ height: navBarHeight }} />
                    </View>
                    {deleteUserModal.status && (
                        <>
                            <TouchableWithoutFeedback
                                onPress={() =>
                                    setDeleteUserModal({
                                        status: false,
                                        title: '',
                                        desc: '',
                                        userLogin: null,
                                        avatar: null,
                                    })
                                }
                            >
                                <Animated.View style={styles.overlay} />
                            </TouchableWithoutFeedback>
                            <BottomSheet.BottomSheet
                                onClose={() =>
                                    setDeleteUserModal({
                                        status: false,
                                        title: '',
                                        desc: '',
                                        userLogin: null,
                                        avatar: null,
                                    })
                                }
                                enablePanDownToClose={true}
                            >
                                <BottomSheetView style={[styles.containerFlex]}>
                                    {deleteUserModalContent(deleteUserModal.title, deleteUserModal.desc)}
                                    <View style={{ height: navBarHeight }} />
                                </BottomSheetView>
                            </BottomSheet.BottomSheet>
                        </>
                    )}

                    {viewModalConnection && (
                        <>
                            <TouchableWithoutFeedback onPress={() => setViewModalConnection(false)}>
                                <Animated.View style={styles.overlay} />
                            </TouchableWithoutFeedback>
                            {Platform.OS === 'web' ? (
                                <View style={{ padding: 24, alignItems: 'center' }}></View>
                            ) : (
                                <BottomSheet.BottomSheet
                                    snapPoints={['50%']}
                                    onClose={() => setViewModalConnection(false)}
                                    enablePanDownToClose={true}
                                >
                                    <BottomSheetView style={styles.containerFlex}>
                                        {viewModalNotConection()}
                                        <View style={{ height: navBarHeight }} />
                                    </BottomSheetView>
                                </BottomSheet.BottomSheet>
                            )}
                        </>
                    )}
                </View>
            ) : (
                <Loader />
            )}
        </>
    )
}

interface ILoginBiometricItem {
    avatar: string
    user_name: string
    userLogin: string
    email: string
    last_connection: string
    setDeleteUserModal: React.Dispatch<React.SetStateAction<any>>
    handleLoginBiometric: () => Promise<void>
    onPressModalUser: (userLogin: string, username: string, avatar: string) => void
}

const LoginBiometricItem = ({
    avatar,
    user_name,
    email,
    last_connection,
    setDeleteUserModal,
    handleLoginBiometric,
    onPressModalUser,
    userLogin,
}: ILoginBiometricItem) => {
    return (
        <View style={{ flex: 1, paddingBottom: 12 }}>
            <View style={[styles.containerUser, { backgroundColor: theme.colors.formsBackground }]}>
                <View style={{ flex: 1, marginRight: 12 }}>
                    <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center' }} onPress={handleLoginBiometric}>
                        <Image style={[styles.avatar, { marginEnd: 12 }]} source={{ uri: avatar ? avatar : avatarPlaceholder }} />

                        <View style={{ flex: 1 }}>
                            {user_name && (
                                <Text numberOfLines={1} style={[styles.username, { marginBottom: 2 }]} ellipsizeMode='tail'>
                                    {user_name.length > 28 ? user_name.substring(0, 28) + '...' : user_name}
                                </Text>
                            )}

                            {email && (
                                <Text numberOfLines={1} style={styles.email}>
                                    {email.length > 28 ? email.substring(0, 28) + '...' : email}
                                </Text>
                            )}
                            {last_connection && (
                                <Text
                                    style={[
                                        styles.lastConnection,
                                        {
                                            marginTop: 6,
                                        },
                                    ]}
                                >
                                    {'Últ. conexión: ' + last_connection}
                                </Text>
                            )}
                        </View>
                    </TouchableOpacity>
                </View>

                <View style={{ alignItems: 'center' }}>
                    <TouchableOpacity onPress={() => onPressModalUser(userLogin, user_name, avatar ? avatar : avatarPlaceholder)}>
                        <Feather name={'x'} size={24} color={theme.colors.colorDisapproved} />
                    </TouchableOpacity>
                </View>
            </View>
        </View>
    )
}
